export default "__VITE_ASSET__CvCi1uqw__"